<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table data-id="widgetPropertyAnalysis" class="widget-large-widgetPropertyAnalysis widgetPropertyAnalysis cellspacing-0 cellpadding-0"  aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large-PropertyAnalysis">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column small-space">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column small-space">&nbsp;</th>

        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column small-space">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column small-space">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tr class="propertyAnalysisChartArea">
      <td colspan="33" style="height: 300px; width:400px;">
        <table class="widget-large-propertyanalysis" aria-hidden="true">
          <thead>
            <tr class="widget-ruller-large-two-columns-one-gap-fifty-percent-propertyanalysis">
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-space">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
              <th scope="col" class="widget-grid-column">&nbsp;</th>
            </tr>
          </thead>
          <tr class="widget-ruller-large-two-columns-one-gap-fifty-percent-propertyanalysis">
          </tr>
          <tr *ngIf="chartsReady">
            <td colspan="16" class="widget-left-chart">
              <div class="k-donut-chart-container-print-fix" style="height: 400px; width:487px;">
                <div class="k-donut-chart-wrapper">
                  <kendo-chart class="k-donut-chart-area report-designer-chart-property-cash-flow" *ngIf="chartsReady" [transitions]="chartTransitionsEnabled">
                    <kendo-chart-title [text]="('incomeAnalysis2.labelRiskProfile' | rdTranslate)" font="bold 16px Arial" color="black"></kendo-chart-title>
                    <kendo-chart-area background="none"></kendo-chart-area>
                    <kendo-chart-value-axis>
                      <kendo-chart-value-axis-item [title]="" name="first" font="12px Arial">
                        <kendo-chart-value-axis-item-labels font="12px Arial"  format="{0:n0}"></kendo-chart-value-axis-item-labels>
                        <kendo-chart-value-axis-item-title font="12px Arial"></kendo-chart-value-axis-item-title>
                      </kendo-chart-value-axis-item>
                    </kendo-chart-value-axis>
                    <kendo-chart-category-axis>
                      <kendo-chart-category-axis-item [categories]="categories" [axisCrossingValue]="[0, categories.length]" [justified]="true">
                        <kendo-chart-category-axis-item-labels font="12px Arial"></kendo-chart-category-axis-item-labels>
                      </kendo-chart-category-axis-item>
                    </kendo-chart-category-axis>
                    <kendo-chart-series>
                      <kendo-chart-series-item *ngFor="let item of seriesExpiryRisk; let i = index;" type="column" [name]="item.name" [color]="item.color" [stack]="true"
                                               [data]="item.data">
                      </kendo-chart-series-item>
                    </kendo-chart-series>
                    <kendo-chart-legend [visible]="true" [labels]="{color: '#000000', font: '12px Arial'}" position="bottom" orientation="horizontal">
                    </kendo-chart-legend>
                  </kendo-chart>
                </div>
              </div>
            </td>
            <td colspan="8">
              <div class="k-donut-chart-container-print-fix" style="height: 480px; width:430px;">
                <kendo-chart class="k-donut-chart-area" *ngIf="chartsReady" [transitions]="chartTransitionsEnabled">
                  <kendo-chart-title text="{{'incomeAnalysis2.labelErvAnalysis' | rdTranslate}}
                                     {{'incomeAnalysis2.labelTop5Tenants' | rdTranslate}}" font="bold 16px Arial" color="black"></kendo-chart-title>
                  <kendo-chart-area background="none" height="400" width="487"></kendo-chart-area>
                  <ng-template kendoChartDonutCenterTemplate>
                    <h2 class="pt-20" [style.fontSize]="(textScale*30) + 'px'">{{currency}}{{ widgetData.totalERV / 1000000 | rdLocalizedNumber:1}}m</h2>
                  </ng-template>
                  <kendo-chart-series>
                    <kendo-chart-series-item type="donut" [data]="ervAnalysisData" categoryField="label" [size]="(donutHoleScale*25)" [holeSize]="(donutHoleScale*75)" [autoFit]="false">
                    </kendo-chart-series-item>
                  </kendo-chart-series>
                  <kendo-chart-legend [visible]="true" [position]="'bottom'" [labels]="{color: '#000000', font: '12px Arial'}" orientation="vertical">
                  </kendo-chart-legend>
                </kendo-chart>
              </div>
            </td>
            <td class="reversion-potential-label" colspan="2">
              <h3>
                <widget-value [align]="'center'" [color]="'black'"><span *ngIf="widgetData.totalReversion > 0">+</span>{{ widgetData.totalReversion | rdLocalizedNumber:0}}% </widget-value>
              <widget-label [widget]="this" [color]="'black'" [fieldName]="'totalReversion'" [align]="'left'"></widget-label></h3>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>
